import React from 'react'
import { Draggable } from 'react-beautiful-dnd';

const SongInfo = ({song, index, editSong, deleteSong}) => {
    return (
        <Draggable key={song.id} draggableId={song.id} index={index}>
        {provided => (
            <div className="songinfo"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            >
            {index+1}. {song.artist} - {song.title} <button onClick={() => {editSong(song)}}>Edit</button> <button onClick={() => {deleteSong(index)}}>Delete</button>
            </div>
        )}
        </Draggable>
    )
}

export default SongInfo
